<template>
  <div>
    <v-btn color="white" style="color: black;" block v-if="selectMode==false" @click="selectMode=true">+ Add User</v-btn>
    <v-combobox v-else outlined v-model="currently_selected" :items="optionsList" @change="itemSelected" label="Select User to be added..." >
    </v-combobox>
  </div>  
</template>

<script>
import {api, srvApi, srvApiNoAuth, PATH, getAssetUrl} from "src/api/index";

export default {
  data() {
    return {
      optionsList: [],
      currently_selected: null,
      selectMode: false,
    }
  },
  methods: {
    itemSelected(selection) {
      this.$emit('itemselected', selection.value);
      this.currently_selected = null;
      this.selectMode=false;
    }
  },
  async mounted() {
    const rsp = await srvApi.get(PATH.USERS_ASOPTIONS);
    this.optionsList.push(...rsp.data);
  }
}
</script>

<style>

</style>